module.exports = __webpack_public_path__ + "img/ico_best_pos.e162733b.png";